import { render, staticRenderFns } from "./forgotForm.vue?vue&type=template&id=6e618e32&"
import script from "./forgotForm.vue?vue&type=script&lang=js&"
export * from "./forgotForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports